import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import { makeStyles } from "tss-react/mui";
import { jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ card: { display: "flex", flexDirection: "column" } }); });
export function TableView(props) { var styles = useStyles().classes; return /*#__PURE__*/ _jsxs(Card, { className: styles.card, children: [props.tabs, /*#__PURE__*/ _jsxs(Grid, { container: true, sx: { justifyContent: "space-between", alignItems: "center" }, children: [props.search, props.moreOptions] }), props.table] }); }
